import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";


export async function getAll(): Promise<any[]> {
  const headers = userService.getAuthHeaders();
  const body: DataSourceRequest = {
    page: 1,
    pageSize: 20,
  };
  return (await axiosInstance.post("/EmailTemplates/GetCustomerTemplates", body, { headers })).data.data;
}

export async function updateTemplate(data: any) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/EmailTemplates/UpdateCustomerTemplate", data, { headers })).data;
}
